import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    background: lightColors.backgroundAlt1
};
export var dark = {
    background: darkColors.backgroundAlt1
};
